/* FS mapping — moved out of pages/FsMapping.jsx in split step 6e (28-Oct-2026), unchanged. */
import React from "react";
import { CheckCircle2 } from "lucide-react";

function StatCard({ label, value, tone = "neutral", testId }) {
  const cls =
    tone === "danger" ? "border-red-300 bg-red-50 text-red-900 dark:bg-red-950/40 dark:text-red-200 dark:border-red-900"
    : tone === "warn"  ? "border-amber-300 bg-amber-50 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-900"
    : tone === "ok"    ? "border-emerald-300 bg-emerald-50 text-emerald-900 dark:bg-emerald-950/30 dark:text-emerald-200 dark:border-emerald-900"
    :                    "border-slate-300 bg-slate-50 text-slate-900 dark:bg-slate-900/60 dark:text-slate-200 dark:border-slate-700";
  return (
    <div className={`rounded-md border p-3 ${cls}`} data-testid={testId}>
      <div className="text-[11px] uppercase tracking-wider opacity-80">{label}</div>
      <div className="mt-1 flex items-center gap-1 text-2xl font-semibold">
        {tone === "ok" && Number(value) > 0 && (
          <CheckCircle2 className="h-4 w-4 text-emerald-600" />
        )}
        {value}
      </div>
    </div>
  );
}

export { StatCard };
